import React, { FC } from 'react';
import './BirthdayCard.css';
import { FaBirthdayCake } from '@/Shared/Lib';


interface BirthdayCardProps {
	name: string;
	birthDate: string; // format 'YYYY-MM-DD'
	role?: string;
	onBirthWish : () => void
}

const BirthdayCard: FC<BirthdayCardProps> = ({ name, birthDate, role, onBirthWish }) => {
	const birth = new Date(birthDate);

	// Format complet (ex: 15 octobre 1990)
	const formattedFullDate = birth.toLocaleDateString('fr-FR', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	});

	return (
		<div className="BirthdayCard">
			<div className="BirthDayCard__avatar">
				<FaBirthdayCake />
			</div>
			<div className="BirthdayCard__info">
				<h4>{name} - {role}</h4>
				<div className="BirthdayCard__body">
					<div className="BirthdayCard__date">{formattedFullDate}</div>
					<button className="BirthdayCard__button" onClick={onBirthWish}>Souhaiter</button>
				</div>
			</div>
		</div>
	);
};

export default BirthdayCard;
